export const stackList = [
   'HTML5/CSS3/SASS/JS',
   'Responsive/Adaptive design',
   'React, React Native',
   'Redux, MobX, Zustand',
   "TypeScript",
   'REST API',
   'Webpack',
   'Node js',
   'Express',
   'Mongoose',
];

export const softList = [
   'Attantion to details',
   'Teamwork',
   'Good communications',
   'Openness to criticism',
   'Adaptability',
];

export const languagesList = [
   'English - Intermediate',
   'Ukrainian - Native',
   'Russian - Native',
];
